import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

const CACHE_KEY = 'app_settings';
const CACHE_EXPIRY = 30 * 60 * 1000; // 30 minutes in milliseconds

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        const cached = localStorage.getItem(CACHE_KEY);

        if (cached) {
            const { data, timestamp } = JSON.parse(cached);
            const now = Date.now();

            if (now - timestamp < CACHE_EXPIRY) {
                setSettings(data); // ✅ Use cached data
                return;
            } else {
                localStorage.removeItem(CACHE_KEY); // ❌ Remove expired cache
            }
        }

        // ⬇️ Fetch fresh settings if no cache or cache expired
        const fetchSettings = async () => {
            try {
                const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
                const Url = process.env.REACT_APP_API_SETTING;
                const response = await axios.get(`${apiBaseUrl}${Url}`);

                const newData = {
                    data: response.data,
                    timestamp: Date.now(),
                };
                localStorage.setItem(CACHE_KEY, JSON.stringify(newData));
                setSettings(response.data);
            } catch (err) {
                console.error('Error fetching settings', err);
            }
        };

        fetchSettings();
    }, []);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
